import { AutoExportDestinationType } from './autoexport-destination-type.model';

export class AutoExportDestinationTypeItem {
    constructor(destinationType: AutoExportDestinationType, destinationTypeText: string) {
        this.destinationType = destinationType;
        this.destinationTypeText = destinationTypeText;
    }

    destinationType: AutoExportDestinationType;
    destinationTypeText: string;
}